import { render, staticRenderFns } from "./BrowserAlert.vue?vue&type=template&id=3decd9b8&"
import script from "./BrowserAlert.vue?vue&type=script&lang=ts&"
export * from "./BrowserAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports